
import { 
  PrimaryButtonStyled, PrimaryButtonProps, PrimaryButton,
} from "lib-core"

export { 
  PrimaryButtonStyled, PrimaryButtonProps, PrimaryButton,
} 


export default PrimaryButton


